import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['submit', 'registrationNumberInput'];

  get form() {
    return document.querySelector('form.new_car, form.edit_car');
  }

  connect() {
    // Prevent submit on Enter
    if (this.form) {
      this.form.onkeypress = function (e) {
        var key = e.charCode || e.keyCode || 0;
        if (key == 13) {
          if (this.canSubmit) return;
          e.preventDefault();
        }
      };
    }
  }

  get interactionsController() {
    return this.application.getControllerForElementAndIdentifier(this.element, 'interactions');
  }

  registrationNumberChanged(event) {
    event && event.preventDefault();

    if (this.canSubmit) {
      this.submitTarget.disabled = false;
    } else {
      this.submitTarget.disabled = true;
    }

    this.registrationNumberInputTarget.value = this.registrationNumberInputTarget.value.toUpperCase();

    const valueLength = this.registrationNumberInputTarget.value.length;
    const autoSubmitLength = parseInt(this.registrationNumberInputTarget.dataset.autoSubmitLength);

    if (this.canSubmit && valueLength === autoSubmitLength) {
      this.interactionsController.refresh(event);
    }
  }

  submit(event) {
    event && event.preventDefault();

    if (this.canSubmit) {
      this.interactionsController.refresh({ target: this.registrationNumberInputTarget });
    }
  }

  get canSubmit() {
    return (
      this.registrationNumberInputTarget.value &&
      this.registrationNumberInputTarget.value.length > 2
    );
  }
}
